// extracted by mini-css-extract-plugin
module.exports = {"root":"Chat_root__1O9-Y","messages":"Chat_messages__LYauT","dateDivider":"Chat_dateDivider__22KVz"};